var map = {
	"./2checkout.png": 7503,
	"./culqi-lg.png": 4965,
	"./culqi.png": 7499,
	"./deposito-bancario.png": 1996,
	"./izipay-lg.png": 2939,
	"./izipay.png": 2217,
	"./kushki.png": 1580,
	"./mercado-pago-lg.png": 10,
	"./mercado-pago.png": 7742,
	"./niubiz-lg.png": 2202,
	"./niubiz.png": 4990,
	"./pago-efectivo-lg.png": 504,
	"./pago-efectivo.png": 3708,
	"./payme.png": 9797,
	"./paypal.png": 6416,
	"./payu.png": 9338,
	"./plin-lg.png": 5268,
	"./plin.png": 7512,
	"./yape-lg.png": 1154,
	"./yape.png": 1638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8241;